<template>
  <li :class="`w-${width}`">
    <a
      class="py-2 text-sm cursor-pointer truncate relative lg:text-md bg-transparent rounded-lg text-[#666666] hover:text-gray-900 focus:outline-none focus:shadow-outline"
      :href="getPath(url)"
      @click.stop.prevent="goPath(url)"
    >
      {{ name }}
      <div v-if="badge" :class="`inline md:absolute -top-2 -right-2 bg-${badge.color || 'rose'}-500 text-white px-0.5 rounded-lg text-xs`">{{badge.title}}</div>
    </a>
  </li>
</template>
<script setup> 
const {goPath,getPath} = useCommon();
  const props = defineProps({
    name: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    badge: {
      type: Object,
      required: false,
    },
    width:{
       type: String,
       default: 'full'
    }
  })
</script>
